export default __webpack_public_path__ + "static/media/Flag_of_Algeria.a9ba9a0d.svg";